import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type ReferralFilters,
  type ReferralPage,
} from "../../../domain/entities/referral-backoffice";
import { type ReferralsBackofficeDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/**
 * `append` distinguishes "load more" (keyset page 2+) from a fresh filter
 * change, which must replace the list rather than grow it.
 */
export const listReferrals = createAsyncThunk<
  ReferralPage & { append: boolean },
  ReferralFilters & { append?: boolean },
  { dispatch: ReferralsBackofficeDispatch; extra: ExtraArgument; state: State }
>(
  thunkTypes.LIST_REFERRALS,
  async ({ append = false, ...filters }, { extra }) => {
    const page = await extra.referralsBackofficeRepo.list(filters);
    return { ...page, append };
  },
);
